"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Conference = exports.PerDeviceConstraints = exports.IceServer = void 0;
const participant_1 = require("./participant");
const media_constraints_1 = require("./media.constraints");
const mocks_1 = require("../../mocks");
const property_1 = require("../../decorators/property");
const constants_1 = require("../../constants");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class IceServer {
}
exports.IceServer = IceServer;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], IceServer.prototype, "username", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], IceServer.prototype, "credential", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, property_1.Property)({ type: [String] }),
    __metadata("design:type", Array)
], IceServer.prototype, "urls", void 0);
class PerDeviceConstraints {
}
exports.PerDeviceConstraints = PerDeviceConstraints;
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => media_constraints_1.MediaConstraints),
    (0, property_1.Property)(),
    __metadata("design:type", media_constraints_1.MediaConstraints)
], PerDeviceConstraints.prototype, "native", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => media_constraints_1.MediaConstraints),
    (0, property_1.Property)(),
    __metadata("design:type", media_constraints_1.MediaConstraints)
], PerDeviceConstraints.prototype, "mobileWeb", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => media_constraints_1.MediaConstraints),
    (0, property_1.Property)(),
    __metadata("design:type", media_constraints_1.MediaConstraints)
], PerDeviceConstraints.prototype, "desktopWeb", void 0);
let Conference = class Conference extends mocks_1.Model {
};
exports.Conference = Conference;
__decorate([
    (0, property_1.Property)(),
    __metadata("design:type", String)
], Conference.prototype, "host", void 0);
__decorate([
    (0, property_1.Property)({ type: mocks_1.ObjectId, index: true }),
    __metadata("design:type", String)
], Conference.prototype, "visitId", void 0);
__decorate([
    (0, property_1.Property)({ type: Date, required: false }),
    __metadata("design:type", Date)
], Conference.prototype, "endedAt", void 0);
__decorate([
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], Conference.prototype, "endingReason", void 0);
__decorate([
    (0, property_1.Property)({ type: String, enum: constants_1.ConferenceTypeEnum }),
    __metadata("design:type", String)
], Conference.prototype, "type", void 0);
__decorate([
    (0, property_1.Property)({ type: participant_1.Participant }),
    __metadata("design:type", participant_1.Participant)
], Conference.prototype, "initiator", void 0);
__decorate([
    (0, property_1.Property)({ type: participant_1.Participant }),
    __metadata("design:type", participant_1.Participant)
], Conference.prototype, "receiver", void 0);
__decorate([
    (0, property_1.Property)({ type: () => [IceServer] }),
    __metadata("design:type", Array)
], Conference.prototype, "iceServers", void 0);
__decorate([
    (0, property_1.Property)(),
    __metadata("design:type", String)
], Conference.prototype, "videoCallVersion", void 0);
__decorate([
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], Conference.prototype, "retryThreshold", void 0);
__decorate([
    (0, property_1.Property)({ type: String, enum: constants_1.CallStateEnum, index: true, default: constants_1.CallStateEnum.initiating }),
    __metadata("design:type", String)
], Conference.prototype, "state", void 0);
__decorate([
    (0, property_1.Property)(),
    __metadata("design:type", String)
], Conference.prototype, "iceTransportPolicy", void 0);
__decorate([
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], Conference.prototype, "videoMaxBitrate", void 0);
__decorate([
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], Conference.prototype, "audioMaxBitrate", void 0);
__decorate([
    (0, property_1.Property)({ type: [String] }),
    __metadata("design:type", Array)
], Conference.prototype, "preferredCodecs", void 0);
__decorate([
    (0, property_1.Property)(),
    __metadata("design:type", Boolean)
], Conference.prototype, "trickleIce", void 0);
__decorate([
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", Number)
], Conference.prototype, "pingTimeout", void 0);
__decorate([
    (0, property_1.Property)({ type: () => PerDeviceConstraints }),
    __metadata("design:type", PerDeviceConstraints)
], Conference.prototype, "mediaConstraints", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: '_id', foreignIdField: 'conferenceId', ref: 'ConferenceEvent', isArray: true }),
    __metadata("design:type", Array)
], Conference.prototype, "events", void 0);
exports.Conference = Conference = __decorate([
    (0, mocks_1.index)({ _id: 1, 'initiator.id': 1 }),
    (0, mocks_1.index)({ _id: 1, 'receiver.id': 1 })
], Conference);
